import React, { useState } from 'react';
import { authFetch } from '../authConfig';

const API_BASE = process.env.REACT_APP_API_URL || '';

function FeedbackModal({ onClose }) {
    const [type, setType] = useState('bug');
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [priority, setPriority] = useState('medium');
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);
        setError(null);

        try {
            const res = await authFetch(`${API_BASE}/api/feedback`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ type, title, description, priority })
            });

            if (!res.ok) {
                const data = await res.json();
                throw new Error(data.error || 'Failed to submit feedback');
            }

            setSubmitted(true);
            setTimeout(() => onClose(), 2000);
        } catch (err) {
            setError(err.message);
        } finally {
            setSubmitting(false);
        }
    };

    if (submitted) {
        return (
            <div className="modal-overlay" onClick={onClose}>
                <div className="feedback-modal" onClick={(e) => e.stopPropagation()}>
                    <div className="feedback-success">
                        <div className="feedback-success-icon">&#10003;</div>
                        <h3>Thank you!</h3>
                        <p>Your feedback has been submitted successfully.</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="feedback-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <span className="modal-title">Submit Feedback</span>
                    <button className="modal-close" onClick={onClose}>&times;</button>
                </div>

                <form onSubmit={handleSubmit} className="feedback-form">
                    <div className="feedback-type-group">
                        <label className={`feedback-type-option ${type === 'bug' ? 'selected' : ''}`}>
                            <input
                                type="radio"
                                name="type"
                                value="bug"
                                checked={type === 'bug'}
                                onChange={(e) => setType(e.target.value)}
                            />
                            <span className="feedback-type-label">Bug Report</span>
                        </label>
                        <label className={`feedback-type-option ${type === 'feature' ? 'selected' : ''}`}>
                            <input
                                type="radio"
                                name="type"
                                value="feature"
                                checked={type === 'feature'}
                                onChange={(e) => setType(e.target.value)}
                            />
                            <span className="feedback-type-label">Feature Request</span>
                        </label>
                    </div>

                    <div className="form-group">
                        <label>Title *</label>
                        <input
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            placeholder={type === 'bug' ? 'Brief description of the issue' : 'What feature would you like?'}
                            required
                            maxLength={255}
                        />
                    </div>

                    <div className="form-group">
                        <label>Description *</label>
                        <textarea
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder={type === 'bug' ? 'Steps to reproduce, expected vs actual behavior...' : 'Describe the feature and how it would help...'}
                            required
                            rows={5}
                            maxLength={10000}
                        />
                    </div>

                    <div className="form-group">
                        <label>Priority</label>
                        <select value={priority} onChange={(e) => setPriority(e.target.value)}>
                            <option value="low">Low</option>
                            <option value="medium">Medium</option>
                            <option value="high">High</option>
                        </select>
                    </div>

                    {error && <div className="feedback-error">{error}</div>}

                    <div className="form-actions">
                        <button type="button" className="secondary" onClick={onClose}>Cancel</button>
                        <button type="submit" disabled={submitting}>
                            {submitting ? 'Submitting...' : 'Submit Feedback'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default FeedbackModal;
